import React from 'react';
import PropTypes from 'prop-types';

const AuthorCard = ({ author }) => {
  return (
    <div
      className="active-author"
      onClick={() =>
        window.open(
          `https://blog.tamtam.pro/fr/author/${author.url}/${author.id}`,
          "_blank",
          "noopener,noreferrer"
        )
      }
    >
      <img src={author.avatarUrl} alt="" />
      <h3>
        {author.firstName} {author.lastName}
      </h3>
    </div>
  );
};

AuthorCard.propTypes = {
  author: PropTypes.shape({
    id: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired
  }).isRequired
};

export default AuthorCard; 